import { Link } from "gatsby";
import { Section, CodeWrapper, NcaLink } from 'nca-acquiring-theme';
import { springCloudS3ReferenceSnippet, springCloudS3Snippet } from "../../../../src/snippets/AwsSpringCloudSnippets";
import * as React from 'react';
export default {
  Link,
  Section,
  CodeWrapper,
  NcaLink,
  springCloudS3ReferenceSnippet,
  springCloudS3Snippet,
  React
};